<template>
    <div class="ma-5">
        <v-data-table
                :headers="headers"
                :items="desserts"
                :height="320"
                :fixed-header="true"
                :search="search"
                class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Grupo</v-toolbar-title>
                    <v-divider
                            class="mx-4"
                            inset
                            vertical
                    ></v-divider>

                    <v-spacer></v-spacer>

                    <v-text-field class="mr-10"
                                  v-model="search"
                                  append-icon="mdi-magnify"
                                  label="Pesquisar"
                                  single-line
                                  hide-details
                    ></v-text-field>
                    <v-dialog persistent v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                         <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.descricao"
                                                label="Digite a descricao do Grupo*"
                                                color="#042333"
                                                autofocus
                                                :error-messages="descricaoErrors"
                                                @input="$v.editedItem.descricao.$touch()"
                                                @blur="$v.editedItem.descricao.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                         <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.sigla"
                                                label="Digite a Sigla do Grupo*"
                                                color="#042333"
                                                autofocus
                                                :error-messages="siglaErrors"
                                                :error="editedItem.sigla && editedItem.sigla.length>3 ? true : false"
                                                @input="$v.editedItem.sigla.$touch()"
                                                @blur="$v.editedItem.sigla.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <span v-if="editedItem.sigla && editedItem.sigla.length>3" style="color: red;font-size: .8rem">A Sigla deve ser igual a 3 caractere</span>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-toolbar>
            </template>

            <template v-slot:item.src_modulo="{ item }">
                <v-icon>{{item.src_modulo}}</v-icon>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                        title="Editar Módulo"
                        class="mr-2"
                        @click="editItem(item)"
                >
                mdi-pencil
                </v-icon>
                <v-icon
                        title="Remover Módulo"
                        @click="deleteItem(item)"
                >
                mdi-delete
                </v-icon>
            </template>

        </v-data-table>
    </div>
</template>
<script>
    import {required} from 'vuelidate/lib/validators'
    import Api from "./../../api/cfg";

    export default {
        data: () => ({
            dialog: false,
            search: '',
            atualizar: 0,
            headers: [
                {
                    text: 'ID',
                    value: 'id',
                },
                {
                    text: 'Descricao',
                    align: 'left',
                    value: 'descricao',
                },
                {
                    text: 'Sigla',
                    align: 'left',
                    value: 'sigla',
                },
                {
                    text: 'Data de Cadastro',
                    align: 'left',
                    value: 'data_cadastro',
                },
                {text: 'Ações', value: 'action', sortable: false},
            ],
            desserts: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                descricao: '',
                data_cadastro: '',
                sigla: ''
            },
            defaultItem: {
                id: '',
                descricao: '',
                data_cadastro: '',
                sigla: ''
            },
            selects: {
                Grupos: {
                    items: [],
                }
            }
        }),

        validations: {
            editedItem: {
                descricao: {
                    required,
                },
                sigla: {
                    required
                }

            }
        },
        
        computed: {
            descricaoErrors() {
                const errors = []
                if (!this.$v.editedItem.descricao.$dirty) return errors
                !this.$v.editedItem.descricao.required && errors.push('Campo Obrigatório.')
                return errors
            },
            siglaErrors() {
                const errors = []
                if (!this.$v.editedItem.sigla.$dirty) return errors
                !this.$v.editedItem.sigla.required && errors.push('Campo Obrigatório.')
                return errors
            },
            formTitle() {
                return this.editedIndex === -1 ? 'Novo Grupo' : 'Editar Grupo'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                this.$store.dispatch("loading/addRequisicao",
                    Api.getGrupos(headers)
                        .then(response => {

                            const token = response.data.token;
                            localStorage.setItem('token', token);

                            if (response.status == 200) {

                                this.desserts = response.data.grupos;

                            }

                        })
                        .catch(() => {
                            this.Helpers.logout();
                        })

                )

            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },
            
            deleteItem(item) {

                this.editedItem = Object.assign({}, item)

                if (confirm('Deseja remover o Grupo?')) {
                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        Api.delGrupo(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {
                                    this.editedItem = {};
                                    this.initialize();

                                    //atualizar grupo filial
                                    this.$emit("novoGrupo", this.atualizar += 1)

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                }

                this.close()

            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {

                if (!this.$v.$invalid && this.editedItem.sigla.length <= 3) {
                    
                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        Api.addGrupo(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                    //atualizar grupo filial
                                    this.$emit("novoGrupo", this.atualizar += 1)

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                    this.close()
                }
            },
        },
    }
</script>
<style scoped>
</style>